import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useAuth } from '../../hooks/useAuth';
import { Shield, Bell } from 'lucide-react';

const MainLayout = ({ children }) => {
    const { user } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    // 檢查是否有權限訪問後台
    if (!user || !['admin', 'dispatcher'].includes(user.user_type)) {
        return (
            <div className="h-screen flex items-center justify-center bg-gray-100">
                <div className="text-center p-8 bg-white rounded-lg shadow-md">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Shield className="w-8 h-8 text-red-500" />
                    </div>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">無訪問權限</h2>
                    <p className="text-gray-600">您沒有權限訪問管理後台。請聯絡系統管理員。</p>
                    <button
                        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                        onClick={() => window.location.href = '/login'}
                    >
                        返回登入頁面
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex h-screen bg-gray-100">
            {/* 側邊選單 */}
            <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

            {/* 主要內容區域 */}
            <div className="flex-1 flex flex-col overflow-hidden">
                <Header onMenuClick={toggleSidebar} />

                {/* 主要內容 */}
                <main className="flex-1 overflow-auto p-6">
                    {children}
                </main>

                <Footer />
            </div>
        </div>
    );
};

export default MainLayout;